<template>
  <v-card flat class="px-5">
    <v-row class="pb-10 pt-2 mb-10">
      <v-col cols="12" :sm="colsSm" :md="colsMd" v-for="(sectionConfig, i) in sections" :key="i">
        <!-- <v-card :height="sectionConfig.height ? sectionConfig.height : '600'" style="overflow-y:auto"> -->
        <v-card style="overflow-y: auto" elevation="6">
          <v-img v-if="sectionConfig.img" :src="imgUrl(sectionConfig.img)" height="150"> </v-img>
          <v-card-text>
            <to-acknowledge v-if="isToAcknowledgeVisible(sectionConfig)" :sectionConfig="sectionConfig"></to-acknowledge>
            <to-read v-else-if="isToReadVisible(sectionConfig)" :sectionConfig="sectionConfig"></to-read>
            <read-history v-else-if="isReadHistoryVisible(sectionConfig)" :sectionConfig="sectionConfig"></read-history>
            <module-link-list v-else-if="isModuleLinkListVisible(sectionConfig)" :sectionConfig="sectionConfig"></module-link-list>
            <news-selection v-else-if="isNewsSelectionVisible(sectionConfig)" :sectionConfig="sectionConfig"></news-selection>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ReadHistory from '@/view-widgets/ReadHistory';
import ToAcknowledge from '@/view-widgets/ToAcknowledge';
import ToRead from '@/view-widgets/ToRead';
import ModuleLinkList from '@/view-widgets/ModuleLinkList';
import NewsSelection from '@/view-widgets/NewsSelection';
import config from '@/common/config';
export default {
  name: 'ListOfSections',
  props: {
    sections: {
      type: Array,
    },
    tab: {
      type: Object,
    },
  },
  components: {
    ToAcknowledge,
    ToRead,
    ReadHistory,
    ModuleLinkList,
    NewsSelection,
  },

  methods: {
    imgUrl(fileName) {
      return `${config.apiUrl}/medias/tenantAssets/${fileName}?token=${this.token}`;
    },
    isAccessible(sectionConf) {
      //TODO:Implement
      return sectionConf.restrictedToMembersOfGroup === '';
    },
    //TODO: apply restrictions
    isToAcknowledgeVisible(sectionConf) {
      return sectionConf.sectionType === 'ToAcknowledge' && this.isAccessible(sectionConf);
    },
    isToReadVisible(sectionConf) {
      return sectionConf.sectionType === 'ToRead' && this.isAccessible(sectionConf);
    },
    isReadHistoryVisible(sectionConf) {
      return sectionConf.sectionType === 'ReadHistory' && this.isAccessible(sectionConf);
    },
    isModuleLinkListVisible(sectionConf) {
      return sectionConf.sectionType === 'ModuleLinkList' && this.isAccessible(sectionConf);
    },
    isNewsSelectionVisible(sectionConf) {
      return sectionConf.sectionType === 'NewsSelection' && this.isAccessible(sectionConf);
    },
  },
  computed: {
    token() {
      return this.$store.state.profile.user.token;
    },
    colsMd() {
      console.debug('this.tab.layoutMaxCols', JSON.stringify(this.tab, null, 2));
      switch (this.tab.layoutMaxCols) {
        case '3':
          if (this.sections.length === 3) return '4';
          return this.sections.length > 3 ? '6' : '12';
        case '2':
          return this.sections.length > 3 ? '6' : '12';
        default:
          return '12';
      }
    },

    colsSm() {
      switch (this.tab.layoutMaxCols) {
        case '3':
          return this.sections.length > 2 ? '6' : '12';
        case '2':
          return this.sections.length > 2 ? '6' : '12';
        default:
          return '12';
      }
    },
  },
};
</script>
